/*************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 *  Copyright 2019 Adobe
 *  All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 **************************************************************************/
import UserContentService from '../services/UserContentService';
import {SET_UCS_FETCH_FINISHED, SET_UCS_TIMEOUT_OR_ERROR, SET_UCS_QUICKLINKS} from '../types';

export const fetchQuickLinks = () => async(dispatch: Function) => {
	const userContentService = new UserContentService();
	const response = await userContentService.fetchQuicklinks();
	if (response.data.length >= 1) {
		/**
		 * Dispatches an action to update the user content store with the updated data from ucs
		 */
		dispatch({
			type: SET_UCS_QUICKLINKS,
			payload: response.data,
		});
	}
	else {
		/**
		 * Dispatches an action to update the user content store to indicate that the user content fetch has errored or timed out.
		 */
		dispatch({
			type: SET_UCS_TIMEOUT_OR_ERROR,
			payload: true,
		});
	}

	/**
	 * Dispatches an action to update the user content store to indicate that the user content fetch has completed (with failure or success)
	 */
	dispatch({
		type: SET_UCS_FETCH_FINISHED,
		payload: true,
	});
};
